import { ProcessMiningState } from '../../../../../reducers/processMiningReducer';

/**
 * Filters process mining states for localStorage persistence.
 * Only loading states need to survive page refresh.
 */
export const processMiningPersistedStateHandler = (processMiningState: ProcessMiningState) => ({
  funnelMaps: Object.fromEntries(
    Object.entries(processMiningState.funnelMaps).filter(
      ([, funnelState]) => funnelState.isLoading,
    ),
  ),
});
